import { ModelBase } from 'store/model-base';

export class CmsUsageDetail extends ModelBase {
    public static storeName: string = 'cmsUsageDetail';

    public header: string;
    public dropdownLabel: string;
    public unlimitedTalk: string;
    public callsLabel: string;
    public minutesLabel: string;
    public totalLabel: string;
    public unlimitedMessage: string;
    public messagesLabel: string;
    public singularCallUnit: string;
    public pluralCallUnit: string;
    public dataUnit: string;
    public ratesVary: string;
    public incomingCallIcon: CmsMediaImage;
    public outgoingCallIcon: CmsMediaImage;
    public incomingMessageIcon: CmsMediaImage;
    public outgoingMessageIcon: CmsMediaImage;
    public dataIcon: CmsMediaImage;
    public globalTravelPassSingularHeader: string;
    public globalTravelPassPluralHeader: string;
    public startDateLabel: string;
    public endDateLabel: string;
    public searchByCountry: string;
}
